export default {
  'tour.name': 'Название тура',
  'tour.en.name': 'Название тура на английском языке',
  'tour.en.fa.name': 'Название тура Персидский',
  'tour.englishTourName': 'Название тура (на английском языке)',
  'tour.persianTourName': 'Название тура (на персидском языке)',
  'tour.necessities': 'Необходимость Английский',
  'tour.en.necessities': 'Необходимость в английском',
  'tour.en.fa.necessities': 'Необходимости на персидском языке',
  'tour.englishNecessities':
    'Основы, необходимые для путешествия (на английском языке)',
  'tour.persianNecessities':
    'Основы, необходимые для путешествия (на персидском)',
  'tour.moneyUnit': 'Денежная единица',
  'tour.price': 'Цена',
  'tour.setPrice': 'Установить цену',
  'tour.type': 'Тип тура',
  'tour.registerDate': 'Дата регистрации',
  'tour.whether': 'Будь то',
  'tour.tourCondition': 'Условия тура',
  'tour.passengerTypes': 'Типы пассажиров',
  'tour.choosePassengerTypes': 'Выберите типы пассажиров',
  'tour.capacity': 'Вместимость количества человек в туре',
  'tour.duration': 'Продолжительность тура (дни)',
  'tour.destination': 'Пункт назначения',
  'tour.destinationCity': 'Город назначения',
  'tour.destinationCountry': 'Страна назначения',
  'tour.en.destination': 'Название пункта назначения на английском языке',
  'tour.en.fa.destination': 'Название пункта назначения Персидский',
  'tour.description': 'описание',
  'tour.en.description': 'описание на английском',
  'tour.en.fa.description': 'описание на персидском языке',
  'tour.englishDescription':
    'Укажите детали, необходимые для поездки (на английском языке)',
  'tour.persianDescription':
    'Укажите детали, необходимые для поездки (на персидском языке)',
  'tour.limitaions': 'Ограничения',
  'tour.en.limitaions': 'Ограничения на английском',
  'tour.englishlimitaions': 'Ограничения на поездки (на английском языке)',
  'tour.persianlimitaions': 'Ограничения на поездки (на персидском языке)',
  'tour.departure': 'выезд',
  'tour.departureCity': 'город отправления',
  'tour.departureCountry': 'Страна отправления',
  'tour.en.departure': 'выезд',
  'tour.en.fa.departure': 'отъезд на персидском языке',
  'tour.difficultyRate': 'Сложность путешествия',
  'tour.departureDate': 'Время начала тура',
  'tour.international': 'Международный',
  'tour.domestic': 'одомашненный',
  'tour.addTour': 'Добавить новый тур',
  'tour.easy': 'Легко',
  'tour.amature': 'Любительское',
  'tour.normal': 'Нормальный',
  'tour.hard': 'Жесткий',
  'tour.veryHard': 'Очень тяжело',
  'tour.road': 'Дорога',
  'tour.flight': 'Полет',
  'tour.marine': 'морской',
  'tour.transportTypes': 'Типы транспорта',
  'tour.chooseTransportTypes': 'Выберите типы транспорта',
  'tour.surpriseTour': 'Сюрприз-тур',
  'tour.ordinaryTour': 'Обычный тур',
  'tour.next': 'Следующий шаг',
  'tour.home': 'Дом',
  'tour.confirm': 'Подтверждать',
  'tour.previous': 'предыдущий шаг',
  'tour.active': 'Активный',
  'tour.disable': 'Запрещать',
  'tour.dollar': 'Доллар США',
  'tour.euro': 'Евро',
  'tour.rial': 'Риал',
  'tour.stepOne': 'Шаг 1',
  'tour.stepTwo': 'Шаг 2',
  'tour.stepThree': 'Шаг 3',
  'tour.stepFour': 'Шаг 4',
  'tour.stepFive': 'Шаг 5',
  'tour.details': 'Подробности',
  'tour.tourDetails': 'Детали тура',
  'tour.cancel': 'Отмена',
  'tour.chooseTourType': 'Выберите свой тип',
  'tour.save': 'Сохранить',
  'tour.tourDetail': 'Информация о туре',
  'tour.furtherInformation': 'Дальнейшая информация',
  'tour.toddlerinownsitPrice': 'Цена для малыша в собственном сиденье',
  'tour.infantPrice': 'Цена для младенца',
  'tour.childPrice': 'Цена на ребенка',
  'tour.adultPrice': 'Цена на взрослого',
  'tour.studentPrice': 'Цена для студента',
  'tour.seniorcitizenPrice': 'Цена для пенсионера',
  'tour.bookingDeadline': 'Крайний срок регистрации на тур',
  'tour.climateType': 'погода во время поездки',
  'tour.step': 'Шаг',
  'tour.tourclimateTitle': 'Выбор климата для тура',
  'tour.tourclimateDescription': 'Выберите желаемую погоду',
  'tour.tourtypeTitle': 'Выбор типа тура',
  'tour.tourtypeDescription': 'Выберите желаемый тип тура',
  'tour.tourtransfertypeTitle': 'Тип транспорта тура',
  'tour.tourtransfertypeDescription':
    'Выберите тип туристического транспорта, который вы хотите',
  'tour.tourpassengertypeTitle': 'Тип пассажира тура ',
  'tour.tourpassengertypeDescription':
    'Выберите тип туристического путешественника, которого вы хотите',
  'tour.tourinformationTitle': 'Информация о туре',
  'tour.tourinformationDescription': 'Введите полную информацию о туре',
  'tour.touroverviewTitle': 'Обзор тура',
  'tour.touroverviewDescription':
    'Просмотрите информацию о туре и при необходимости отредактируйте',
  'tour.tourpriceTitle': 'Стоимость тура',
  'tour.overview': 'обзор ',
  'tour.tourpriceDescription':
    'Введите цены для каждого пассажира по вашему выбору',
  'tour.tourScheduling': 'Расписание туров',
  'tour.mainTourInformation': 'Основная информация о туре',
  'tour.tourConditions': 'Условия тура',
  'tour.tourRestrictionsRequirements': 'Ограничения и требования тура',
  'tour.tourRegistration': 'Регистрация тура',
  'tour.addNewTour': 'Добавить новый тур',
  'tour.name': 'Название тура',
  'tour.en.name': 'Название тура на английском языке',
  'tour.en.fa.name': 'Название тура Персидский',
  'tour.englishTourName': 'Название тура (на английском языке)',
  'tour.persianTourName': 'Название тура (на персидском языке)',
  'tour.necessities': 'Необходимость Английский',
  'tour.en.necessities': 'Необходимость в английском',
  'tour.en.fa.necessities': 'Необходимости на персидском языке',
  'tour.englishNecessities':
    'Основы, необходимые для путешествия (на английском языке)',
  'tour.persianNecessities':
    'Основы, необходимые для путешествия (на персидском)',
  'tour.moneyUnit': 'Денежная единица',
  'tour.price': 'Цена',
  'tour.setPrice': 'Установить цену',
  'tour.type': 'Тип тура',
  'tour.registerDate': 'Дата регистрации',
  'tour.whether': 'Будь то',
  'tour.tourCondition': 'Условия тура',
  'tour.passengerTypes': 'Типы пассажиров',
  'tour.choosePassengerTypes': 'Выберите типы пассажиров',
  'tour.capacity': 'Вместимость количества человек в туре',
  'tour.duration': 'Продолжительность тура (дни)',
  'tour.destination': 'Пункт назначения',
  'tour.destinationCity': 'Город назначения',
  'tour.destinationCountry': 'Страна назначения',
  'tour.en.destination': 'Название пункта назначения на английском языке',
  'tour.en.fa.destination': 'Название пункта назначения Персидский',
  'tour.description': 'описание',
  'tour.en.description': 'описание на английском',
  'tour.en.fa.description': 'описание на персидском языке',
  'tour.englishDescription':
    'Укажите детали, необходимые для поездки (на английском языке)',
  'tour.persianDescription':
    'Укажите детали, необходимые для поездки (на персидском языке)',
  'tour.limitaions': 'Ограничения',
  'tour.en.limitaions': 'Ограничения на английском',
  'tour.englishlimitaions': 'Ограничения на поездки (на английском языке)',
  'tour.persianlimitaions': 'Ограничения на поездки (на персидском языке)',
  'tour.departure': 'выезд',
  'tour.departureCity': 'город отправления',
  'tour.departureCountry': 'Страна отправления',
  'tour.en.departure': 'выезд',
  'tour.en.fa.departure': 'отъезд на персидском языке',
  'tour.difficultyRate': 'Сложность путешествия',
  'tour.departureDate': 'Время начала тура',
  'tour.international': 'Международный',
  'tour.domestic': 'одомашненный',
  'tour.addTour': 'Добавить новый тур',
  'tour.easy': 'Легко',
  'tour.amature': 'Любительское',
  'tour.normal': 'Нормальный',
  'tour.hard': 'Жесткий',
  'tour.veryHard': 'Очень тяжело',
  'tour.road': 'Дорога',
  'tour.flight': 'Полет',
  'tour.marine': 'морской',
  'tour.transportTypes': 'Типы транспорта',
  'tour.chooseTransportTypes': 'Выберите типы транспорта',
  'tour.surpriseTour': 'Сюрприз-тур',
  'tour.ordinaryTour': 'Обычный тур',
  'tour.next': 'Следующий шаг',
  'tour.home': 'Дом',
  'tour.confirm': 'Подтверждать',
  'tour.previous': 'предыдущий шаг',
  'tour.active': 'Активный',
  'tour.disable': 'Запрещать',
  'tour.dollar': 'Доллар США',
  'tour.euro': 'Евро',
  'tour.rial': 'Риал',
  'tour.stepOne': 'Шаг 1',
  'tour.stepTwo': 'Шаг 2',
  'tour.stepThree': 'Шаг 3',
  'tour.stepFour': 'Шаг 4',
  'tour.stepFive': 'Шаг 5',
  'tour.details': 'Подробности',
  'tour.tourDetails': 'Детали тура',
  'tour.cancel': 'Отмена',
  'tour.chooseTourType': 'Выберите свой тип',
  'tour.save': 'Сохранить',
  'tour.tourDetail': 'Информация о туре',
  'tour.furtherInformation': 'Дальнейшая информация',
  'tour.toddlerinownsitPrice': 'Цена для малыша в собственном сиденье',
  'tour.infantPrice': 'Цена для младенца',
  'tour.childPrice': 'Цена на ребенка',
  'tour.adultPrice': 'Цена на взрослого',
  'tour.studentPrice': 'Цена для студента',
  'tour.seniorcitizenPrice': 'Цена для пенсионера',
  'tour.bookingDeadline': 'Крайний срок регистрации на тур',
  'tour.climateType': 'погода во время поездки',
  'tour.step': 'Шаг',
  'tour.tourclimateTitle': 'Выбор климата для тура',
  'tour.tourclimateDescription': 'Выберите желаемую погоду',
  'tour.tourtypeTitle': 'Выбор типа тура',
  'tour.tourtypeDescription': 'Выберите желаемый тип тура',
  'tour.tourtransfertypeTitle': 'Тип транспорта тура',
  'tour.tourtransfertypeDescription':
    'Выберите тип туристического транспорта, который вы хотите',
  'tour.tourpassengertypeTitle': 'Тип пассажира тура ',
  'tour.tourpassengertypeDescription':
    'Выберите тип туристического путешественника, которого вы хотите',
  'tour.tourinformationTitle': 'Информация о туре',
  'tour.tourinformationDescription': 'Введите полную информацию о туре',
  'tour.touroverviewTitle': 'Обзор тура',
  'tour.touroverviewDescription':
    'Просмотрите информацию о туре и при необходимости отредактируйте',
  'tour.tourpriceTitle': 'Стоимость тура',
  'tour.overview': 'обзор ',
  'tour.tourpriceDescription':
    'Введите цены для каждого пассажира по вашему выбору',
  'tour.tourScheduling': 'Расписание туров',
  'tour.mainTourInformation': 'Основная информация о туре',
  'tour.tourConditions': 'Условия тура',
  'tour.tourRestrictionsRequirements': 'Ограничения и требования тура',
  'tour.tourRegistration': 'Регистрация тура',
  'tour.addNewTour': 'Добавить новый тур',

  'tour.tourInformationTemporarilyRecorded':
    'Информация о туре временно записана',
  'tour.yourTourSuccessfullyRegistered': 'Ваш тур успешно зарегистрирован',
  'tour.tourInformationTemporarilyRecorded':
    'Информация о туре временно записана',
  'tour.yourTourSuccessfullyRegistered': 'Ваш тур успешно зарегистрирован',

  'tour.tourpassengertype': 'Тип пассажира',
  'tour.tourtransfertype': 'Тур Трансфер',
  'tour.tourType': 'Тип тура',
  'tour.nameen': 'Название тура (на английском языке)',
  'tour.namefa': 'Название тура (на персидском языке)',
  'tour.bookingDeadLine': 'Крайний срок регистрации на тур',
  'tour.climateTypes': 'Климат тура',
  'tour.limitationsen': 'Ограничения на поездки (на английском языке)',
  'tour.limitationsfa': 'Ограничения на поездки (на персидском языке)',
  'tour.necessitiesen':
    'Основы, необходимые для путешествия (на английском языке)',
  'tour.necessitiesfa':
    'Основы, необходимые для путешествия (на персидском языке)',
  'tour.descriptionen':
    'Укажите детали, необходимые для поездки (на английском языке)',
  'tour.descriptionfa':
    'Укажите детали, необходимые для поездки (на персидском языке)',
  'tour.tourpassengertype': 'Тип пассажира',
  'tour.tourtransfertype': 'Тур Трансфер',
  'tour.tourType': 'Тип тура',
  'tour.nameen': 'Название тура (на английском языке)',
  'tour.namefa': 'Название тура (на персидском языке)',
  'tour.bookingDeadLine': 'Крайний срок регистрации на тур',
  'tour.climateTypes': 'Климат тура',
  'tour.limitationsen': 'Ограничения на поездки (на английском языке)',
  'tour.limitationsfa': 'Ограничения на поездки (на персидском языке)',
  'tour.necessitiesen':
    'Основы, необходимые для путешествия (на английском языке)',
  'tour.necessitiesfa':
    'Основы, необходимые для путешествия (на персидском языке)',
  'tour.descriptionen':
    'Укажите детали, необходимые для поездки (на английском языке)',
  'tour.descriptionfa':
    'Укажите детали, необходимые для поездки (на персидском языке)',

  'tour.editTourTransferType': 'Редактировать информацию о трансфере тура',
  'tour.editTourPassengerType':
    'Редактировать информацию о пассажирах и цены для каждого пассажира',
  'tour.editTourInformation': 'Редактировать общую информацию о туре',
  'tour.tourRegistration': 'Регистрация тура',
  'tour.isActive': 'Деятельность',
  'tour.editTourPassengerType': 'Изменить тип пассажира тура',
  'tour.editTourTransferType': 'Изменить тип трансфера тура',
  'tour.editTourInformationType': 'Редактировать информацию о туре',
  'tour.editTourPrice': 'Изменить цену пассажира',
  'tour.attachments': 'Вложения',
  'tour.cancelingRules': 'Правила отмены',
  'tour.editTourTransferType': 'Редактировать информацию о трансфере тура',
  'tour.editTourPassengerType':
    'Редактировать информацию о пассажирах и цены для каждого пассажира',
  'tour.editTourInformation': 'Редактировать общую информацию о туре',
  'tour.tourRegistration': 'Регистрация тура',
  'tour.isActive': 'Деятельность',
  'tour.editTourPassengerType': 'Изменить тип пассажира тура',
  'tour.editTourTransferType': 'Изменить тип трансфера тура',
  'tour.editTourInformationType': 'Редактировать информацию о туре',
  'tour.editTourPrice': 'Изменить цену пассажира',
  'tour.attachments': 'Вложения',
  'tour.cancelingRules': 'Правила отмены',

  'tour.endBookingDeadLine': 'Крайний срок бронирования',
  'tour.endPrice': 'Конечная цена',
  'tour.startPrice': 'Начальная цена',
  'tour.endDuration': 'Конечная продолжительность',
  'tour.startDuration': 'Продолжительность начала',
  'tour.endDepartureDate': 'Конечная дата отъезда',
  'tour.startDepartureDate': 'Дата начала отъезда',
  'tour.originterminal': 'Терминал отправления',
  'tour.destinationterminal': 'терминал назначения',
  'tour.vehicletype': 'Тип машины',
  'tour.starttime': 'Время начала',
  'tour.endtime': 'время окончания',
  'tour.invalidreturndate': 'Дата окончания меньше даты начала',
  'tour.invalidstartdate': 'Дата начала больше даты окончания',
  'tour.facilities': 'Экскурсионные объекты',
  'tour.invalidEndTime': 'Время окончания меньше времени начала',
  'tour.drafts': 'Черновики',
  'tour.useprevioustours': 'Использование предыдущих туров',
  'tour.Draft': 'проект тура',
  'tour.creationDate': 'Дата создания',
  'tour.dateCreatedFrom': 'Дата создания из',
  'tour.dateCreatedUntil': 'Дата создания до',
  'tour.ordering': 'Заказ',
  'tour.basedTourName': 'Судя по названию тура',
  'tour.basedNamePlace': 'Судя по названию места',
  'tour.search': 'Поиск по имени и местоположению',
  'tour.facilitynotdeclared': 'объект не заявлен',
  'tour.basicinfonotfound': 'информация о туре не указана',
  'tour.finaldestination': 'конечный пункт назначения',
  'tour.insertdraft': 'вставить черновик',
  'tour.updatetdraft': 'обновить черновик',
  'tour.ageSuffering': 'возрастные страдания',
  'tour.finaldestination': 'конечный пункт назначения',
  'tour.insertsuccess': 'Тур успешно зарегистрирован',
  'tour.draftinsertsuccess': 'Проект тура успешно зарегистрирован',
  'tour.inserterror': 'Регистрация тура не удалась',
  'tour.updatesuccess': 'Тур успешно обновлен.',
  'tour.draftupdatesuccess': 'Проект тура успешно обновлен.',
  'tour.updateerror': 'Обновление тура не удалось.',
  'tour.deletesuccess': 'Тур успешно удален',
  'tour.draftdeletesuccess': 'Черновик тура успешно удален.',
  'tour.deleteerror': 'Удаление тура не удалось.',
  'tour.deletedrafttour': 'Удалить проект тура',
  'tour.deletedrafttourmessage': 'Вы уверены, что хотите удалить проект тура?',
  'tour.male': 'мужской',
  'tour.female': 'женский',
  'tour.all': 'все',
  'tour.changefieldwarning':
    'Если в важные поля будут внесены изменения, информация о следующих шагах будет удалена. Нажмите, чтобы получить дополнительную информацию',
  'tour.importantfieldsintroduction':
    'применение изменений в следующих полях приведет к потере данных следующих форм',
  'tour.tournotspecified': 'информация о туре не указана',
  'tour.stoptype': 'тип остановки',
  'tour.searchfacilities': 'Поисковые возможности',
  'tour.confirmdata': 'Вся зарегистрированная информация проверена',
  'tour.vehiclenamefa': 'местное название автомобиля',
  'tour.vehiclenameen': 'английское название автомобиля',
  'tour.transportproviderlocal': 'Локальное имя поставщика транспорта',
  'tour.transportprovideren': 'Английское название поставщика транспорта',
  'tour.addnewtourtype': 'Добавить новый тип тура',
  'tour.submittourtype': 'отправить новый тип тура',
  'tour.tourtypenamefa': 'Название типа тура на фарси',
  'tour.tourtypenameen': 'Английское название типа тура',
  'tour.tourtypeinsertsuccess': 'вставить удалось',
  'tour.tourtypeinserterror': 'вставить неудачно',
  'tour.originairport': 'аэропорт отправления',
  'tour.destinationairport': 'аэропорт назначения',
  'tour.arrivaldateto': 'Дата прибытия',
  'tour.arrivaltimeto': 'время прибытия',
  'tour.nextmovedate': 'следующая дата начала перевозки',
  'tour.nextmovetime': 'следующее время начала транспортировки',
  'tour.tourimages': 'изображения туров',
  'tour.viewimages': 'просмотреть изображения',
  'tour.addnewtourfacility': 'Добавление новых туристических объектов',
  'tour.tourfacilitynamefa': 'Название туристических объектов на фарси',
  'tour.tourfacilitynameen': 'Английское название туристических объектов',
  'tour.originterminalfa': 'Локальное имя исходного терминала',
  'tour.originterminalen': 'Английское название исходного терминала',
  'tour.destinationterminalfa': 'Местное название терминала назначения',
  'tour.destinationterminalen': 'Английское название терминала назначения',
  'tour.underreviewing': 'на рассмотрении',
  'tour.expired': 'истекший',
  'tour.residence': 'резиденция',
  'tour.pricepercustomer': 'цена на человека',
  'tour.userstours': 'мои туры',
  'tour.usersalltours': 'все туры',
  'tour.usersactivetours': 'активные туры',
  'tour.usersexpiredtours': 'просроченные туры',
  'tour.changerequiredfields': 'показать результат проверки оператора',
  'tour.requiredreviews': 'необходимые отзывы',
  'tour.rejectionreason': 'причина отклонения',
  'tour.rejectiondescription': 'описание отклонения',
  'tour.starttime': 'Время начала',
  'tour.endtime': 'Время окончания',
  'tour.imageuploadfailed': 'Не удалось загрузить изображение.',
};
